const PRIMARY_CHART_COLOUR = '#057ec1';

const GA4_METRICS_I18N_PATH = `ANALYTICS.GA4METRICS`;

const GA4_ACTIVE_USERS_METRICS = `${GA4_METRICS_I18N_PATH}.ACTIVE_USERS`;
const GA4_ACTIVE_USERS_CARD_TEXT = {
  title: { key: `${GA4_ACTIVE_USERS_METRICS}.TITLE` },
  subtitle: { key: `${GA4_ACTIVE_USERS_METRICS}.SUBTITLE` },
};

const GA4_SESSIONS_METRICS = `${GA4_METRICS_I18N_PATH}.SESSIONS`;
const GA4_SESSIONS_CARD_TEXT = {
  title: { key: `${GA4_SESSIONS_METRICS}.TITLE` },
  subtitle: { key: `${GA4_SESSIONS_METRICS}.SUBTITLE` },
};

const GA4_AVERAGE_SESSION_METRICS = `${GA4_METRICS_I18N_PATH}.AVERAGE_SESSION`;
const GA4_AVERAGE_SESSION_CARD_TEXT = {
  title: { key: `${GA4_AVERAGE_SESSION_METRICS}.TITLE` },
  subtitle: { key: `${GA4_AVERAGE_SESSION_METRICS}.SUBTITLE` },
};

const GA4_BOUNCE_RATE_METRICS = `${GA4_METRICS_I18N_PATH}.BOUNCE_RATE`;
const GA4_BOUNCE_RATE_CARD_TEXT = {
  title: { key: `${GA4_BOUNCE_RATE_METRICS}.TITLE` },
  subtitle: { key: `${GA4_BOUNCE_RATE_METRICS}.SUBTITLE` },
};

const GA4_ENGAGED_SESSIONS_METRICS = `${GA4_METRICS_I18N_PATH}.ENGAGED_SESSIONS`;
const GA4_ENGAGED_SESSIONS_CARD_TEXT = {
  title: { key: `${GA4_ENGAGED_SESSIONS_METRICS}.TITLE` },
  subtitle: { key: `${GA4_ENGAGED_SESSIONS_METRICS}.SUBTITLE` },
};
const GA4_PAGE_VIEWS_METRICS = `${GA4_METRICS_I18N_PATH}.PAGE_VIEWS`;
const GA4_PAGE_VIEWS_CARD_TEXT = {
  title: { key: `${GA4_PAGE_VIEWS_METRICS}.TITLE` },
  subtitle: { key: `${GA4_PAGE_VIEWS_METRICS}.SUBTITLE` },
};

const GA4_PAGE_VIEWS_PER_SESSION_METRICS = `${GA4_METRICS_I18N_PATH}.PAGE_VIEWS_PER_SESSION`;
const GA4_PAGE_VIEWS_PER_SESSION_CARD_TEXT = {
  title: { key: `${GA4_PAGE_VIEWS_PER_SESSION_METRICS}.TITLE` },
  subtitle: { key: `${GA4_PAGE_VIEWS_PER_SESSION_METRICS}.SUBTITLE` },
};

const GA4_NEW_USERS_METRICS = `${GA4_METRICS_I18N_PATH}.NEW_USERS`;
const GA4_NEW_USERS_CARD_TEXT = {
  title: { key: `${GA4_NEW_USERS_METRICS}.TITLE` },
  subtitle: { key: `${GA4_NEW_USERS_METRICS}.SUBTITLE` },
};

export const GA4_ACTIVE_USERS_CHART_CONFIG = {
  header: {
    title: GA4_ACTIVE_USERS_CARD_TEXT.title,
    subtitle: GA4_ACTIVE_USERS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Active Users',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_SESSIONS_CHART_CONFIG = {
  header: {
    title: GA4_SESSIONS_CARD_TEXT.title,
    subtitle: GA4_SESSIONS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Sessions',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_AVERAGE_SESSION_CHART_CONFIG = {
  header: {
    title: GA4_AVERAGE_SESSION_CARD_TEXT.title,
    subtitle: GA4_AVERAGE_SESSION_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Engaged Sessions',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_PAGE_VIEWS_CHART_CONFIG = {
  header: {
    title: GA4_PAGE_VIEWS_CARD_TEXT.title,
    subtitle: GA4_PAGE_VIEWS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Page Views',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_PAGE_VIEWS_PER_SESSION_CHART_CONFIG = {
  header: {
    title: GA4_PAGE_VIEWS_PER_SESSION_CARD_TEXT.title,
    subtitle: GA4_PAGE_VIEWS_PER_SESSION_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Page Views Per Session',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_NEW_USERS_CHART_CONFIG = {
  header: {
    title: GA4_NEW_USERS_CARD_TEXT.title,
    subtitle: GA4_NEW_USERS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'New Users',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_BOUNCE_RATE_CHART_CONFIG = {
  header: {
    title: GA4_BOUNCE_RATE_CARD_TEXT.title,
    subtitle: GA4_BOUNCE_RATE_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Bounce Rate',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

export const GA4_ENGAGED_SESSIONS_CHART_CONFIG = {
  header: {
    title: GA4_ENGAGED_SESSIONS_CARD_TEXT.title,
    subtitle: GA4_ENGAGED_SESSIONS_CARD_TEXT.subtitle,
  },
  chartColors: [
    {
      name: 'Enagaed Sessions',
      value: PRIMARY_CHART_COLOUR,
    },
  ],
};

const GA_TRAFFIC_SOURCES_METRICS = `${GA4_METRICS_I18N_PATH}.TRAFFIC_SOURCES`;
const GA_TRAFFIC_SOURCES_CARD_TEXT = {
  title: { key: `${GA_TRAFFIC_SOURCES_METRICS}.TITLE` },
  headingColumnTitle: { key: '' },
  columnTitle: { key: `${GA_TRAFFIC_SOURCES_METRICS}.COLUMN_TITLE` },
};

const GA_TOP_REFERRAL_SOURCES_METRICS = `${GA4_METRICS_I18N_PATH}.TOP_REFERRAL_SOURCES`;
const GA_TOP_REFERRAL_SOURCES_CARD_TEXT = {
  title: { key: `${GA_TOP_REFERRAL_SOURCES_METRICS}.TITLE` },
  headingColumnTitle: { key: '' },
  columnTitle: { key: `${GA_TOP_REFERRAL_SOURCES_METRICS}.COLUMN_TITLE` },
};

const GA_GOALS_METRICS = `${GA4_METRICS_I18N_PATH}.GOALS`;
const GA_GOALS_CARD_TEXT = {
  title: { key: `${GA_GOALS_METRICS}.TITLE` },
  headingColumnTitle: { key: `${GA_GOALS_METRICS}.HEADING_COLUMN_TITLE` },
  columnTitle: { key: `${GA_GOALS_METRICS}.COLUMN_TITLE` },
};

export const GA_TRAFFIC_SOURCES_CONFIG = {
  header: {
    title: GA_TRAFFIC_SOURCES_CARD_TEXT.title,
  },
  columnConfig: {
    columnTitles: [GA_TRAFFIC_SOURCES_CARD_TEXT.headingColumnTitle, GA_TRAFFIC_SOURCES_CARD_TEXT.columnTitle],
  },
};

export const GA_TOP_REFERRAL_SOURCES_CONFIG = {
  header: {
    title: GA_TOP_REFERRAL_SOURCES_CARD_TEXT.title,
  },
  columnConfig: {
    columnTitles: [GA_TOP_REFERRAL_SOURCES_CARD_TEXT.headingColumnTitle, GA_TOP_REFERRAL_SOURCES_CARD_TEXT.columnTitle],
  },
};

export const GA_GOALS_CONFIG = {
  header: {
    title: GA_GOALS_CARD_TEXT.title,
  },
  column: {
    headingColumnTitle: GA_GOALS_CARD_TEXT.headingColumnTitle,
    columnTitle: GA_GOALS_CARD_TEXT.columnTitle,
  },
};
export const COLLECTION_DAYS_THRESHOLD = 89;
